import React, { Component } from 'react';
import _ from 'lodash';


class DonorCategoriesSide extends Component {

    constructor(props) {
        super(props);
        this.navroute = this.navroute.bind(this);
        this.prepareModules = this.prepareModules.bind(this);
    }

    componentDidMount() {

    }

    navroute(donorCatId) {
        this.props.handleSlideCategoryChange(donorCatId);
    }

    prepareModules() {
        if (this.props.donorCats.length === 0) {
            return (<div />)
        }
        //onMouseDown={this.route(row.id, row.display_module_type)}
        return (
            this.props.donorCats.map(function (row, i) {
                return (
                    <div key={row.id} onMouseDown={() => this.navroute(row.id)} className="phand" >
                        <span>{row.name}</span>
                    </div>
                )
            }, this)
        )
    }

    render() {

        let modules = this.prepareModules();

        return (
            <div style={{ color: 'black', height: '100vh', textAlign: 'vertical', fontSize: this.props.screen.r16_9.p10*.325 }}>
                <div className="outerC">
                    <div className="middleC">
                        <div style={{ textAlign: 'left', display: 'inline-block', lineHeight: '2' }}>
                            <div>
                                <b>Categories</b>
                            </div>
                            {modules}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default DonorCategoriesSide;



// WEBPACK FOOTER //
// ./src/Components/Donor/DonorCategoriesSide.js